import { useMemo } from "react";
import { usePageContext } from "@/hooks/usePageContext";
import type { PageContext } from "gatsby/createPages";
import {
  type DockContent,
  type RouteDock,
  resolveDockContent,
  useShellStore,
} from "../stores/shellStore";

export const useRouteDock = (): RouteDock => {
  const { dock }: PageContext = usePageContext();
  return dock ?? "betslip";
};

export const useDockContent = () => {
  const routeDock = useRouteDock();
  return useShellStore((state) =>
    resolveDockContent(state.dockContentOverride, routeDock),
  );
};

export const useDockState = () => {
  const content = useDockContent();
  const open = useShellStore((state) => state.dockOpen);

  return { content, open };
};

export const useDockActions = () => {
  const routeDock = useRouteDock();

  return useMemo(() => {
    const { openDock, toggleDock, revealDock } = useShellStore.getState();
    return {
      openDock: (content: DockContent) => openDock(content, routeDock),
      toggleDock: (content: DockContent) => toggleDock(content, routeDock),
      revealDock: (content: DockContent) => revealDock(content, routeDock),
    };
  }, [routeDock]);
};
